import React from 'react';
import PropTypes from 'prop-types';
import { Paper, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  inset1x: {
    padding: theme.spacing(1),
  },
  inset2x: {
    padding: theme.spacing(2),
  },
  inset3x: {
    padding: theme.spacing(3),
  },
  gutterTop1x: {
    marginTop: theme.spacing(1),
  },
  gutterTop2x: {
    marginTop: theme.spacing(2),
  },
  fullWidth: {
    width: '100%',
  },
}));

function UPaper({
  className, children, gutterTop, insetSize, fullWidth,
}) {
  const classes = useStyles();
  const gutterTopSize = typeof gutterTop === 'boolean' ? '1x' : gutterTop;
  const gutterTopNumberSize = ['1x', '2x'].includes(gutterTopSize) ? gutterTopSize : '1x';
  const gutterTopClass = `gutterTop${gutterTopNumberSize}`;

  const insetSizeNumber = ['1x', '2x', '3x'].includes(insetSize) ? insetSize : '2x';
  const insetSizeClass = `inset${insetSizeNumber}`;

  return (
    <Paper className={clsx(
      className,
      classes[insetSizeClass],
      classes[gutterTopClass],
      fullWidth ? classes.fullWidth : '',
    )}
    >
      {children}
    </Paper>
  );
}

UPaper.defaultProps = {
  className: '',
  gutterTop: false,
  insetSize: '2x',
  fullWidth: false,
};

UPaper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gutterTop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['1x', '2x'])]),
  insetSize: PropTypes.oneOf(['1x', '2x', '3x']),
  fullWidth: PropTypes.bool,
};

export default UPaper;
